/**
 * A duplicate of the nestjs RequestMethod class for use in the front end
 */
export enum RequestMethod {
	GET = 0,
	POST = 1,
	PUT = 2,
	DELETE = 3,
	PATCH = 4,
	ALL = 5,
	OPTIONS = 6,
	HEAD = 7,
	SEARCH = 8,
}
